import React, { memo, useEffect, useRef } from 'react';
// import { useTranslation } from 'react-i18next';
// import Button from '@material-ui/core/Button';
import LoadingView from '../../../shared/components/LoadingView/LoadingView';
import GeneralError from '../../../shared/components/GeneralError/GeneralError';
import UserDetailHeaderContainer from '../../containers/UserDetailHeaderContainer';
import GeneralInformationContainer from '../../containers/GeneralInformationContainer';
import ExpressConfigurationContainer from '../../containers/ExpressConfigurationContainer';
import styles from './userDetail.module.scss';

export default memo(function UserDetail(props) {
    // const [t] = useTranslation('common');
    // const [advancedConfiguration, setAdvancedConfiguration] = useState(false);
    // const [firstRender, setFirstRender] = useState(true);
    const configurationContainer = useRef(null);
    // const advancedConfigurationButtonContainer = useRef(null);
    // const advancedConfigurationButton = useRef(null);
    // const advancedConfigurationContainer = useRef(null);

    useEffect(() => {
        if (props.match.params.id) {
            props.getUserRequest(props.match.params.id);
        }

        return () => props.cleanUser();
    }, []);

    // useLayoutEffect(() => {
    //     if (advancedConfiguration) {
    //         advancedConfigurationContainer.current.style.display = 'block';

    //         showAdvancedConfiguration();
    //     } else {
    //         hideAdvancedConfiguration();
    //         setFirstRender(false);
    //         setTimeout(() => advancedConfigurationContainer.current.style.display = 'none', 500);
    //     }
    // }, [advancedConfiguration]);

    // const toggleAdvancedConfiguration = () => setAdvancedConfiguration(!advancedConfiguration);

    // const showAdvancedConfiguration = () => advancedConfigurationButtonContainer.current.scrollIntoView({ behavior: 'smooth' });

    // const hideAdvancedConfiguration = () => {
    //     if (!firstRender) {
    //         const scrollTopHeight =
    //             configurationContainer.current.scrollHeight
    //             - configurationContainer.current.offsetHeight
    //             - advancedConfigurationContainer.current.scrollHeight
    //             - advancedConfigurationButton.current.clientHeight;

    //         configurationContainer.current.scroll({
    //             top: scrollTopHeight,
    //             behavior: 'smooth'
    //         });
    //     }
    // };

    return (
        <>
            {
                props.edition.fetching &&
                !props.edition.error &&
                <LoadingView />
            }
            {!props.edition.fetching && props.edition.error && <GeneralError menu="USER" message="general_error" />}
            {
                !props.edition.fetching &&
                !props.edition.error &&
                <div className={styles.container}>
                    <UserDetailHeaderContainer />
                    <div className={styles.configurationContainer} ref={configurationContainer}>
                        <div>
                            <GeneralInformationContainer />
                            <ExpressConfigurationContainer />
                        </div>
                        {/* <div className={styles.advancedConfigurationButtonContainer} ref={advancedConfigurationButtonContainer}>
                            <div ref={advancedConfigurationButton}>
                                <Button
                                    className={styles.advancedConfigurationButton}
                                    onClick={toggleAdvancedConfiguration}
                                    variant="contained"
                                >
                                    {
                                        advancedConfiguration
                                            ? t('common:hide_advanced_configuration')
                                            : t('common:show_advanced_configuration')
                                    }
                                </Button>
                            </div>
                        </div>
                        <div className={styles.advancedConfigurationContainer} ref={advancedConfigurationContainer}>
                            <GeneralInformationContainer />
                            <GeneralInformationContainer />
                            <GeneralInformationContainer />
                            <GeneralInformationContainer />
                        </div> */}
                    </div>
                </div>
            }

        </>
    );
}, (prevProps, nextProps) => prevProps.edition === nextProps.edition);
